<template>
  <el-dialog title="修改密码" :close-on-click-modal="false">
    <el-form>
      <el-form-item label="原密码">
        <el-input type="password" v-model="form.oldPassword" />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input type="password" v-model="form.newPassword" />
        <div class="tip">需8位以上且含字母+数字</div>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input type="password" v-model="form.confirmPassword" />
      </el-form-item>
    </el-form>
    <el-button @click="submit">提交</el-button>
  </el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        // 双师学生列表
        form: [],
      };
    },
    methods: {

    }
  }
</script>
